import _cloneDeep from 'lodash/cloneDeep';
import _set from 'lodash/set';
import {setEmailChange, resetEmailChanges, addEmailTrigger, deleteEmailTrigger, updateEmailTemplate} from './helpers';

const calendarEvents = {
  setCalendarEventEmailChange(state, calendarEventTrigger) {
    setEmailChange(state, 'calendarEventEmailChanges', calendarEventTrigger, 'id');
  },
  resetCalendarEventEmailChanges(state) {
    resetEmailChanges(state, 'calendarEventEmailChanges');
  },
  setPastEventEmailChange(state, calendarEventTrigger) {
    setEmailChange(state, 'pastEventEmailChanges', calendarEventTrigger, 'id');
  },
  setPastEventNotificationChange(state, calendarNotificationTrigger) {
    setEmailChange(state, 'pastEventNotificationChanges', calendarNotificationTrigger, 'index');
  },
  resetPastEventChanges(state) {
    resetEmailChanges(state, 'pastEventEmailChanges');
    resetEmailChanges(state, 'pastEventNotificationChanges');
  },
  calendarEventsAddTrigger(state, payload) {
    const { newTrigger, originalTriggerId } = payload;
    addEmailTrigger(state, 'calendarEventEmails', newTrigger, originalTriggerId);
  },
  calendarEventsDeleteTrigger(state, payload) {
    const { originalTriggerId, deleteTriggerId } = payload;
    deleteEmailTrigger(state, 'calendarEventEmails', originalTriggerId, deleteTriggerId);
  },
  updateCalendarEmailTemplate(state, payload) {
    const { updatedTemplate, triggerId } = payload;
    updateEmailTemplate(state, 'calendarEventEmails', updatedTemplate, triggerId);
  },
  updatePastEmailTemplate(state, payload) {
    const { updatedTemplate, triggerId } = payload;
    updateEmailTemplate(state, 'pastEventEmails', updatedTemplate, triggerId);
  },
};

const metrics = {
  expandAllMetrics(state, payload) {
    const { allMetrics, shouldExpand } = payload;
    state.metricsExpanded = allMetrics.map(() => [shouldExpand]);
  },
  toggleExpandedMetric(state, index) {
    const oldVal = state.metricsExpanded[index][0];
    state.metricsExpanded.splice(index, 1);
    state.metricsExpanded.splice(index, 0, [!oldVal]);
  },
};

const navigation = {
  toggleSidebar(state) {
    state.sidebarOpen = !state.sidebarOpen;
  },
};

const mutations = {
  setState(state, payload) {
    const { path, value } = payload;
    _set(state, path, value);
  },
  ...calendarEvents,
  ...metrics,
  ...navigation,
};

export default mutations;
